import { Injectable } from '@angular/core';
import { map, merge, Observable, of, partition, Subject, tap } from 'rxjs';
import { GridHelpers } from './helpers/grid';
import { QuoteData } from './quote-data';

@Injectable()
export class FireRatingService {
  calculated$: Observable<boolean>;
  private calculated = new Subject<boolean>();

  constructor() {
    this.calculated$ = this.calculated.asObservable();
  }

  calculate(quoteData: QuoteData): Observable<QuoteData> {
    const [costFireRating, noCostFireRating] = partition(
      of(quoteData),
      (qd: QuoteData) => qd.FireRatingData.CostFireRating
    );

    return merge(
      costFireRating.pipe(
        tap(() => this.calculated.next(false)),
        map((newQd: QuoteData) => {
          if (newQd.FireRatingData.FasciaLengthAuto) {
            this.calculateFasciaLength(newQd);
          }
          this.calculated.next(true);
          return newQd;
        })
      ),
      noCostFireRating
    );
  }

  private calculateFasciaLength(quoteData: QuoteData): void {
    quoteData.FireRatingData.FasciaLength =
      GridHelpers.calculateRoundedPerimeter(quoteData);
  }
}
